import React from 'react'

import { TextClamp } from '../components/text/TextClamp'
import { EditableText } from '../slides/EditableText'

/**
 * The bullets slot (plots plan Stage 2, AA): a slide's insight bullets, each an accent
 * dot in an 8px column beside its text, clamped to `maxLines` (or editable). Size, gap
 * and line budget come from the host: the choice rails vary them by count
 * (`insightBulletRhythm`), the other slides fix them.
 */
export interface SlotBulletsProps {
  bullets: Array<string>
  fontSize: number
  gap: number
  maxLines: number
  dotColor: string
  /** Gap between the dot column and the text. */
  columnGap?: number
  color?: string
  /** Extra layout style on the list (a margin, a fixed width), as the host places it. */
  style?: React.CSSProperties
  testId?: string
  editable?: boolean
  onEdit?: (field: string, value: string) => void
  renderMode?: 'interactive' | 'static'
}

export function SlotBullets(props: SlotBulletsProps) {
  const { bullets, fontSize, gap, maxLines, dotColor, columnGap = 12, color = 'var(--slide-text-primary)', style, testId, editable, onEdit, renderMode } = props
  return (
    <div data-testid={testId} style={{ display: 'flex', flexDirection: 'column', gap, ...style }}>
      {bullets.map((bullet, i) => (
        <div key={i} style={{ display: 'grid', gridTemplateColumns: '8px 1fr', columnGap, alignItems: 'start' }}>
          <span aria-hidden="true" style={{ color: dotColor, fontSize, lineHeight: '1.5' }}>•</span>
          {editable && onEdit ? (
            <EditableText
              value={bullet}
              field={`insightBullets.${i}`}
              editable
              onEdit={onEdit}
              tag="span"
              style={{ fontSize, color, lineHeight: '1.5' }}
            />
          ) : (
            <TextClamp minLines={1} maxLines={maxLines} lineHeight="1.5" renderMode={renderMode} style={{ fontSize, color }}>
              {bullet}
            </TextClamp>
          )}
        </div>
      ))}
    </div>
  )
}
